import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Hotelrunner**
 *
 * @exports bs_292
 * @category engines
 */
function factory({ window, document, thn }) {
  const engine = {};
  let refreshPrice;
  let onPurchaseEvent = null;

  /**
     * @memberOf module:bs_292
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      let lang;
      // Detect language on home page
      const isGrandMakelHotel = thn.data.propertyId === 1037371;
      const isGTowerExecutive = thn.data.propertyId === 1045005;
      const uidBtnLangWhitelist = [1036055];
      const isBtnEl = document.querySelector('.btn-lang, .langs .active');
      const btnEl = isBtnEl?.dataset?.code;
      const isSearchEl = document.querySelector('.searchButton button');
      const searchEl = isSearchEl?.textContent;
      const langBoxEl = document.querySelector('.language-box span');

      if (isGTowerExecutive && !window.location.hostname.includes('hotelrunner')) {
        resolve('en');
        return;
      }

      if (isGrandMakelHotel && !window.location.pathname.includes('bv3')) {
        lang = window.lang_code;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }
      if (btnEl && uidBtnLangWhitelist.includes(thn.data.accountUserId)) { // selector for the Home page
        lang = btnEl.match(/\w{2}/) && btnEl.match(/\w{2}/)[0];
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }
      if (searchEl) { // selector for the engine
        const searchLangs = {
          Search: 'en',
          Rechercher: 'fr',
          Ara: 'tr',
          搜索: 'zh',
          Поиск: 'ru',
          Căutare: 'ro',
          검색: 'ko',
          Cerca: 'it',
          Buscar: 'es',
          Αναζήτηση: 'el',
          Suche: 'de',
          Търси: 'bg',
          Axtarış: 'az',

        };
        lang = searchLangs[searchEl];
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // Home Page: ArtHotel158 & A&MHotel
      if ([1052829, 1052831].includes(thn.data.propertyId) && langBoxEl) {
        lang = langBoxEl.getAttribute('class').slice(-2);
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // BE Page: A&MHotel
      if ([1052831].includes(thn.data.propertyId)) {
        lang = document.documentElement.lang;
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
      }

      // GrandHotelNirvana
      if ([1052830].includes(thn.data.propertyId)) {
        if (window.location.pathname === '/') {
          resolve('bg');
          return;
        } if (window.location.pathname === '/en-US/') {
          resolve('en');
          return;
        }
      }

      reject();
    });
  };

  /**
     * @memberOf module:bs_292
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    const langDictionary = {
      en: 'en-US',
      bg: 'bg',
    };

    // Example: https://cape-bodrum-beach-resort-1.hotelrunner.com/bv3/search?device_type=desktop
    // Example with params: https://cape-bodrum-beach-resort-1.hotelrunner.com/bv3/search?search=%7B%22checkin_date%22:%222023-08-01%22,%22checkout_date%22:%222023-08-02%22,%22day_count%22:1,%22room_count%22:1,%22total_adult%22:2,%22total_child%22:0,%22rooms%22:%5B%7B%22adult_count%22:2,%22child_count%22:0,%22guest_count%22:2,%22child_ages%22:%5B%5D%7D%5D,%22guest_rooms%22:%7B%220%22:%7B%22adult_count%22:2,%22guest_count%22:2,%22child_count%22:0,%22child_ages%22:%5B%5D%7D%7D%7D
    // https://olive-villas-sozopol-1.hotelrunner.com/bv3/search?search=%7B%22checkin_date%22:%222025-07-21%22,%22checkout_date%22:%222025-07-22%22,%22day_count%22:1,%22room_count%22:1,%22total_adult%22:2,%22total_child%22:1,%22rooms%22:%5B%7B%22adult_count%22:2,%22guest_count%22:3,%22child_count%22:1,%22child_ages%22:%5B2%5D%7D%5D,%22guest_rooms%22:%7B%220%22:%7B%22adult_count%22:2,%22guest_count%22:3,%22child_count%22:1,%22child_ages%22:%5B2%5D%7D%7D%7D

    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/bv3/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    const search = {};
    const dateBegin = ctx.data.dateBegin;
    const dateEnd = ctx.data.dateEnd;
    let adults = 0;
    let children = 0;
    ctx.data.roomsDispo.forEach((room) => {
      adults += room.adults;
      children += room.children;
    });
    search.checkin_date = dateBegin;
    search.checkout_date = dateEnd;
    search.day_count = thn.daysBetween(dateBegin, dateEnd);
    search.room_count = ctx.data?.roomsDispo?.length || 1;
    search.total_adult = adults;
    search.total_child = children;
    const guestsRooms = {};
    if (ctx.data?.roomsDispo) {
      ctx.data.roomsDispo.forEach((room, index) => {
        guestsRooms[index] = {
          adult_count: room.adults,
          child_count: room.children,
          child_ages: room.childrenAges || [],
          guest_count: room.adults + room.children,
        };
      });
    }

    search.guest_rooms = guestsRooms;
    url.searchParams.set('search', JSON.stringify(search));
    url.searchParams.set('locale', langDictionary[ctx.data.language] || ctx.data.language);
    url.searchParams.set('currency', '[currency]');

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
    * @memberOf module:bs_292
    * @see {@link onStateChange}
    *
    * @param {object} ctx - The context object.
    */
  engine.onStateChange = function onStateChange() {
    setTimeout(thn.pageCheck, 200);
  };

  /**
     * @memberOf module:bs_292
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot(ctx) {

    const body = document.querySelector('body');
    if (body) {
      const refreshPage = thn.debounce(thn.pageCheck, 500);

      thn.observeDom(body, refreshPage, {
        attributes: true,
      });

      thn.shutdown(() => {
        refreshPage.cancel();
        thn.stopObserveDom(body, refreshPage);
      });
    }

    // The message that appears in the case of a sold out does not disappear from searching for new dates when rooms are available.
    // It is a function used as a solution to it.
    // By request, we only applied this to Yamak hotels.
    const isYamakHotelCollection = thn.data.accountUserId === 1042441;
    if (isYamakHotelCollection) {
      const onPriceSet = ({ changed, firstTime }) => {
        if (changed && !firstTime) {
          thn.pageCheck({ force: true });
        }
      };
      const eventName = 'thn:price.set';
      thn.bus.on(eventName, onPriceSet);
      thn.shutdown(() => {
        thn.bus.detach(eventName, onPriceSet);
      });
    }

  };

  /**
     * @memberOf module:bs_292
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const container = document.querySelector('.mainContainer, main, .contentContainer');
    if (container && !refreshPrice) {
      refreshPrice = thn.debounce(() => {
        const loading = document.querySelector('[class^=placeholderBox], .room-container.placeholder, .placeholder-fill');
        ctx.widget.hide();
        if (!loading) {
          ctx.widget.update();
        }
      }, 500);
    }

    thn.observeDom(container, refreshPrice, {
      childList: true,
      subtree: true,
    });

    thn.pageUnload(() => {
      refreshPrice.cancel();
      thn.stopObserveDom(container, refreshPrice);
      refreshPrice = null;
    });
  };

  /**
     * @memberOf module:bs_292
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const resultContainer = document.querySelector('.search-result-container');

    // Dates
    const datePicker = document.querySelector('#hotelDatePickerInput')?.placeholder || document.querySelector('[aria-describedby="datepicker-value"]')?.textContent;
    const datePicketDates = datePicker?.split(' - ');
    const datePickerBegin = datePicketDates?.[0];
    const datePickerEnd = datePicketDates?.[1];

    const domDateBegin = document.querySelector('#dateRange .checkin')?.textContent;
    const domDateEnd = document.querySelector('#dateRange .checkout')?.textContent;

    const searchObject = thn.parseUrlParameter('search');
    const searchDateBegin = searchObject && JSON.parse(searchObject).checkin_date.replace(/-/g, '/');
    const searchDateEnd = searchObject && JSON.parse(searchObject).checkout_date.replace(/-/g, '/');

    const dateBeginText = datePickerBegin || domDateBegin;
    const dateEndText = datePickerEnd || domDateEnd;

    const dateBegin = (dateBeginText && translateDate(dateBeginText, thn.data.language || 'en')) || searchDateBegin;
    const dateEnd = (dateEndText && translateDate(dateEndText, thn.data.language || 'en')) || searchDateEnd;

    let nights;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(dateBegin, dateEnd);
    }

    // Guests, Adults & Children
    const dataLayerSearch = window.dataLayer?.filter((obj) => obj[1] === 'search').pop();
    const roomParams = !dataLayerSearch && window.dataLayer.filter((obj) => obj[0] === 'room_params').pop();
    const rooms = thn.parseNumber((document.querySelector('.searchRooms') || {}).textContent) || thn.objectGet(dataLayerSearch, 'room_count') || thn.objectGet(roomParams, 'room_count');
    const adults = thn.parseNumber((document.querySelector('.searchGuests') || {}).textContent) || thn.objectGet(dataLayerSearch, 'total_adult') || thn.objectGet(dataLayerSearch, 'adult_count') || JSON.parse(thn.parseUrlParameter('search'))?.total_adult;
    const children = thn.parseNumber((document.querySelector('.searchGuests>span') || {}).textContent) || thn.objectGet(dataLayerSearch, 'total_child') || thn.objectGet(dataLayerSearch, 'child_count') || JSON.parse(thn.parseUrlParameter('search'))?.total_child;

    widgetData.rooms = rooms || 1;
    widgetData.adults = adults || 2;
    widgetData.children = children || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    let childrenAges = [];

    let roomsInfo = JSON.parse(thn.parseUrlParameter('search'))?.rooms;
    if (!roomsInfo) {
      roomsInfo = JSON.parse(thn.parseUrlParameter('search'))?.guest_rooms;
    }
    if (roomsInfo) {
      for (let i = 0; i < roomsInfo.length; i += 1) {
        const ages = roomsInfo[i]?.child_ages;
        childrenAges = childrenAges?.concat(ages);
      }
    }

    const roomInfo = {
      adults: widgetData.adults,
      children: widgetData.children,
      childrenAges: childrenAges,
    };

    widgetData.roomsDispo = [roomInfo];

    // no availrable room
    const roomAvailability = document.querySelectorAll('.room:not(.uav)');
    const roomCards = document.querySelectorAll('.contentContainerCard');
    const noAvailableMessage = document.querySelector('.unavailable-room-message');
    const noAvailableBedge = document.querySelector('.badgeNotAvailable');
    const emptyState = document.querySelector('app-empty-state');
    const noAvailableRooms = document.querySelector('.no-available-room , .contentContainer .noSelection')
                          || emptyState
                          || !!(noAvailableMessage && document.querySelectorAll('.unavailable-room-message').length === roomAvailability.length)
                          || !!(noAvailableBedge && document.querySelectorAll('.badgeNotAvailable').length === roomCards.length)
                          || !!(resultContainer && roomAvailability?.length === 0);
    if (noAvailableRooms) {
      widgetData.noRooms = true;
      return widgetData;
    }
    // Prices & Currency || No Rooms
    const recomendedPriceWrapper = document.querySelector('.recommendCardDetailsPricing .price');
    const recomendedPriceEls = recomendedPriceWrapper && [...recomendedPriceWrapper.childNodes].filter((el) => el.nodeName === '#text');
    const recommendedPrice = recomendedPriceEls && recomendedPriceEls.length && thn.parseNumber(recomendedPriceEls[0].textContent);

    widgetData.currency = (recomendedPriceEls && recomendedPriceEls.length && thn.parseCurrency(recomendedPriceEls[0]?.textContent)) || document.querySelector('.currencyLanguageSelector')?.textContent.split('-')?.[1].match(/\((.*?)\)/)?.[1];

    let price;

    /*
        *   The lowest price is shown in the card for only one room.
        *   When we select more than one room the price will be the same and the total won't be shown
        *   until we add the two rooms.
        *
        *   On some searches, there's a "recommended" price card, with the lowest total of all the rooms.
        */

    // multiple rooms
    if (widgetData.rooms > 1) {
      // lowest recommended total price is visible
      if (recommendedPrice) {
        price = recommendedPrice;
      } else {
        // can't get total
        widgetData.priceSpecial = 1;
      }

      // normal behavior
    } else {
      const prices = [...document.querySelectorAll('.cardMainDetails, .room:not(.uav) .price-details')].map((el) => {
        let priceRoom = thn.parseNumber(el.querySelector('.d-block.showPrice, .price')?.textContent);

        if (!widgetData.currency) {
          widgetData.currency = thn.parseCurrency((el.querySelector('.price') || {}).textContent);
        }
        if (!priceRoom && el.querySelector('.price .ng-star-inserted')) {
          priceRoom = thn.parseNumber((el.querySelector('.showPrice') || {}).textContent);
        }

        return priceRoom;
      }).filter(Boolean);

      if (prices.length) {
        price = Math.min(...prices);
      }
    }

    if (price && nights && widgetData.currency) {
      widgetData.price = price / nights;
      widgetData.set = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_292
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {
    if (onPurchaseEvent || ctx.widget.isSet()) {
      return;
    }

    onPurchaseEvent = ({ message }) => {
      if (message?.[0] === 'affiliation' && ctx.widget.setData().isSet()) {
        ctx.widget.save();
      }
    };

    thn.bus.on('dataLayer:push', onPurchaseEvent, true);

    thn.pageUnload(() => {
      thn.bus.detach('dataLayer:push', onPurchaseEvent);
      onPurchaseEvent = null;
    });
  };

  /**
     * @memberOf module:bs_292
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;

    // Dates from Reservation Details (Booking Summary)
    const checkinDay = document.querySelector('.check-in .dateNumber')?.textContent;
    const checkinMonthYear = document.querySelector('.check-in .dateMonth')?.textContent;
    const checkoutDay = document.querySelector('.check-out .dateNumber')?.textContent;
    const checkoutMonthYear = document.querySelector('.check-out .dateMonth')?.textContent;

    const checkinDate = translateDate(`${checkinDay} ${checkinMonthYear}`, thn.data.language);
    const checkoutDate = translateDate(`${checkoutDay} ${checkoutMonthYear}`, thn.data.language);

    // Dates from Date picker
    const domDateBegin = (document.querySelector('#dateRange .checkin'))?.textContent;
    const domDateEnd = (document.querySelector('#dateRange .checkout'))?.textContent;

    // Hotels that need to get dates from Reservation Details (Booking Summary): Melas Hotel, Byotell Hotel,  Oudaya Hotel
    const hotelsUseSummaryToGetDates = [1036860, 1036604, 1028923, 1034026, 1037368].includes(thn.data.propertyId);

    const dateBegin = hotelsUseSummaryToGetDates ? checkinDate : (domDateBegin && translateDate(domDateBegin, thn.data.language || 'en')) || dataLayer?.find((item) => item[0] === 'line_items')?.[1]?.[0]?.checkin_date;
    const dateEnd = hotelsUseSummaryToGetDates ? checkoutDate : (domDateEnd && translateDate(domDateEnd, thn.data.language || 'en')) || dataLayer?.find((item) => item[0] === 'line_items')?.[1]?.[0]?.checkout_date;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
    }

    // price & currency
    widgetData.price = thn.parseNumber((document.querySelector('.summaryTotals .totalRow') || {}).textContent) || dataLayer?.find((item) => item[0] === 'order_total')?.[1];
    widgetData.currency = thn.parseCurrency((document.querySelector('.summaryTotals .totalRow') || {}).textContent) || dataLayer?.find((item) => item[0] === 'currency')?.[1];

    // Guests
    const adults = thn.parseNumber((document.querySelector('.guestCount') || {}).textContent) || dataLayer?.find((item) => item[0] === 'line_items')?.[1]?.[0]?.total_adult;

    if (adults) {
      widgetData.adults = adults;
      widgetData.children = 0;
      widgetData.guests = adults;
    }

    // booking ID
    let bookingId = thn.parseUrlParameter('o_number') || dataLayer?.find((item) => item[0] === 'order_number')?.[1];

    if (!bookingId) {
      const bookingIdWrapper = document.querySelector('h5.cardTitle small.text-secondary');
      const bookingIdEls = bookingIdWrapper && [...bookingIdWrapper.childNodes].filter((el) => el.nodeName === '#text');
      const bookingIdText = bookingIdEls && bookingIdEls.length && bookingIdEls[0].textContent;
      const bookingIdSplitted = bookingIdText && bookingIdText.split(':');
      bookingId = bookingIdSplitted && bookingIdSplitted.length > 1 && bookingIdSplitted[1].trim();
    }

    if (bookingId) {
      widgetData.bookingId = bookingId;
    }

    return widgetData;
  };

  return engine;
}

export { factory };
